<template>
  <div>
    <plan-info :recurrence="recurrence" :product="product" :applied-coupon="coupon"></plan-info>
    <coupon-input @coupon-update="onCouponUpdate"></coupon-input>
  </div>
</template>

<script>
import PlanInfo from "./PlanInfo.vue";

export default {
  name: "PartialCheckoutForm",
  components: {PlanInfo},
  data() {
    return {
      coupon: undefined,
    }
  },
  props: {
    product: String,
    recurrence: String,
  },
  methods: {
    onCouponUpdate(coupon) {
      this.coupon = coupon;
    }
  }
}
</script>

<style scoped>

</style>
